Vue.component("Hotspot", {
    props: ["hotspot", "index", "settings", "resetHotspot", "activeHotspot"],
    template: `
    <transition :name="hotspotEntranceType">
        <li class="hotspot" 
            v-if="hotspotShown"
            :class="[getHotspotType, {'hotspot--flipped': flipped}, {'hotspot--notext': showLabel === false}, {'hotspot--hidden': isHidden}]"
            :style="[{left: hotspot.x + 'px', top: hotspot.y + 'px'}, inactiveHotspot]"
            @click="goto(hotspot); onClickAnimation();">

            <transition enter-active-class="animated flipInX"
                leave-active-class="animated flipOutX">
                <div class="hotspot__title_wrapper" >
                    <h2 :style="getTextColor" v-if="showLabel" v-html="hotspot.title"></h2>

                    <div class="hotspot-button" :style="[getContinuousHotspotAnimation, getClickHotspotAnimation, getHotspotColor]">
                    </div>
                </div>
            </transition>
        </li>
    </transition>
`,
    data() {
        return {
            // variables for this instance of the hotspot
            hotspotShown: false,
            minDelay: 2,
            maxDelay: 14,
            animatingClick: false,
            showText: false,

            //default hotspot style values. can be overwritten in manifest.
            hasUniqueStyle: false,
            flipped: false,
            hotspotcolor: '',
            textcolor: '',

            //global variables for hotspots
            hotspotType: this.settings.hotspotType,

            hotspotEntranceType: this.settings.hotspotEntranceType,
            loopAnimationType: this.settings.loopAnimationType,
            clickAnimationType: this.settings.clickAnimationType,

            animationCycleStyle: this.settings.animationCycleStyle
        }
    },
    methods: {
        goto(hotspot) {
            if (!hotspot.hasOwnProperty("properties")) {
                this.$emit("goto", hotspot);
                return;
            }


            if (hotspot.properties.showTransitionVideo) {
                this.currentHotspot = hotspot;

                var self = this;

                ShowTransition(hotspot.properties.transitionVideoUrl, "0.15s", function () {
                    self.$emit("goto", self.currentHotspot);
                });


            } else {
                this.$emit("goto", hotspot);
            }
        },
        getRandomAnimationDelay(min, max) {
            //return a random value for random animations
            return Math.random() * (max - min) + min;
        },
        onClickAnimation() {
            // set the hotspot to animate as feedback if the hotspot is pressed
            if (this.animatingClick == false)
                this.animatingClick = true;
            setTimeout(() => {
                this.animatingClick = false;
                this.$emit("resetHotspotAnimationCycle");
            }, 1500);
        },
        hotspotEntrance() {
            //handler for the entrance of hotspots when scene is loaded.
            // load in one by one, depending on their position in the hotspots array of the scene
            let delay = 0;
            delay = (this.index * 200) + 200;

            setTimeout(() => {
                this.hotspotShown = true;
            }, delay);
            setTimeout(() => {
                this.showText = true;
            }, delay + 800);
        },
        getUniqueStyle() {
            // determine if hotspot has any specific style specified in the manifest
            this.hasUniqueStyle = this.hotspot.hasOwnProperty("hotspotstyle");
            if (this.hasUniqueStyle) {
                this.setUniqueStyles(this.hotspot.hotspotstyle);
            }
        },
        setUniqueStyles(style) {
            // get specific style for this hotspot from the manifest.

            //is hotspot flipped?
            this.flipped = style.flipped;

            //get type
            style.hasOwnProperty("hotspotType") ? this.hotspotType = style.hotspotType : this.hotspotType;

            //animations
            style.hasOwnProperty('hotspotentrance') ? this.hotspotEntranceType = style.hotspotentrance : this.hotspotEntranceType;
            style.hasOwnProperty("loopanimation") ? this.loopAnimationType = style.loopanimation : this.loopAnimationType;
            style.hasOwnProperty("clickanimation") ? this.clickAnimationType = style.clickanimation : this.clickAnimationType;

            //colors
            style.hasOwnProperty('hotspotcolor') ? this.hotspotcolor = style.hotspotcolor : this.hotspotcolor;
            style.hasOwnProperty('textcolor') ? this.textcolor = style.textcolor : this.hotspotcolor;
        },
        getAnimationCycleStyle() {
            // helper for assigning animation cycle style from the config.js
            switch (this.animationCycleStyle) {
                case "random":
                    return this.getRandomAnimationDelay(this.minDelay, this.maxDelay).toFixed(1) + 's'
                case "pulse":
                    return ((this.index * 0.1) + 1.5) + "s"
            }
        }
    },
    created() {
        this.getUniqueStyle();
    },
    mounted() {
        this.eventHandlers = {};
        this.eventHandlers["hotspot-animation-cycle-disable"] = () => {
            this.animationCycleEnabled = false;
        }
        this.eventHandlers["hotspot-animation-cycle-enable"] = () => {
            this.animationCycleEnabled = true;
        }

        app.radio.$on("hotspot-animation-cycle-disable", this.eventHandlers["hotspot-animation-cycle-disable"]);
        app.radio.$on("hotspot-animation-cycle-enable", this.eventHandlers["hotspot-animation-cycle-enable"]);

        this.hotspotEntrance();
    },
    destroyed() {
        app.radio.$off("hotspot-animation-cycle-disable", this.eventHandlers["hotspot-animation-cycle-disable"]);
        app.radio.$off("hotspot-animation-cycle-enable", this.eventHandlers["hotspot-animation-cycle-enable"]);
    },
    computed: {
        getHotspotType() {
            // assign Link as hot spot type if hotspot has any other hotspot children elements in manifest.
            // else assign the given type.
            if (this.hotspot.hotspots == true) {
                return "linkhotspot"
            } else {
                return this.hotspot.type
            }
        },
        getContinuousHotspotAnimation() {
            // assign the looping animation on hotspots, as well as keeping them synced with resetHotspot.
            if (this.resetHotspot == true) {
                return

            } else {
                return {
                    'animation-name': this.loopAnimationType,
                    'animation-iteration-count': 'infinite',
                    'animation-duration': '15s',
                    'animation-delay': this.getAnimationCycleStyle()
                }
            }
        },
        getClickHotspotAnimation() {
            // Assign the click animation when hotspot is clicked.
            if (this.animatingClick) {
                return {
                    'animation-name': this.clickAnimationType,
                    'animation-iteration-count': '1',
                    'animation-duration': '1.5s',
                    'animation-delay': '0s'
                }
            } else {
                return
            }
        },
        getHotspotColor() {
            // assign custom hotspotcolor.
            if (this.hotspotcolor != '') {
                return {
                    'background': this.hotspotcolor
                }
            } else {
                return
            }

        },
        getTextColor() {
            // assign custom textcolor.
            if (this.textcolor != '') {
                return {
                    'color': this.textcolor
                }
            } else {
                return
            }
        },
        isActiveHotspot() {
            if ((this.index == this.activeHotspot || this.hotspotType != "two-step") && this.showText) {
                return true;
            } else {
                return false;
            }
        },
        inactiveHotspot() {
            if (!this.isActiveHotspot && this.hotspotType != "two-step") {
                return {
                    'padding': 0
                }
            }
        },
        showLabel() {
            return this.hotspot.title.length !== 0 && this.hotspot.title !== undefined
        },
        isHidden() {
            return this.hotspot.hidden || this.hotspot.hotspotstyle.hidden
        }
    }
})